<template>
  <div class="page-loading" v-show="showLoading">
    <Loading />
  </div>
  <el-config-provider :locale="currentLocale">
    <router-view>
      <template #default="{ Component, route }">
        <keep-alive :include="usePermissionStoreHook().cachePageList">
          <component :is="Component" :key="route.name" />
        </keep-alive>
      </template>
    </router-view>
  </el-config-provider>
</template>

<script setup>
import { ElConfigProvider } from "element-plus";
import { computed, ref } from "vue";
import { useI18n } from "vue-i18n";
import bus from "vue3-eventbus";

import Loading from "@/components/Loading/index.vue";
import { usePermissionStoreHook } from "@/store/modules/permission";

import { getElementPlusLocale } from "./locales";

const { locale } = useI18n();

const showLoading = ref(false);

const currentLocale = computed(() => getElementPlusLocale(locale.value));

bus.on("togglePageLoading", show => {
  showLoading.value = show;
});

defineOptions({
  name: "app"
});
</script>
<style scoped>
.page-loading {
  position: absolute;
  z-index: 9999;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
